import { render, staticRenderFns } from "./Sociology.vue?vue&type=template&id=481db88e&scoped=true&"
import script from "./Sociology.vue?vue&type=script&lang=js&"
export * from "./Sociology.vue?vue&type=script&lang=js&"
import style0 from "./Sociology.vue?vue&type=style&index=0&id=481db88e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481db88e",
  null
  
)

export default component.exports